import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type CreateSubscriptionBody = NonNullable<
  paths['/api/v1/subscriptions']['post']['requestBody']
>['content']['application/json'];
export type CreateSubscriptionResponse =
  paths['/api/v1/subscriptions']['post']['responses'][201]['content']['application/json']['subscription'];

export type MySubscriptionResponse =
  paths['/api/v1/subscriptions/me']['get']['responses'][200]['content']['application/json']['subscription'];

export type ChangeSubscriptionBody = NonNullable<
  paths['/api/v1/subscriptions/me/change']['post']['requestBody']
>['content']['application/json'];
export type ChangeSubscriptionResponse =
  paths['/api/v1/subscriptions/me/change']['post']['responses'][200]['content']['application/json']['subscription'];

export type CancelSubscriptionBody = NonNullable<
  paths['/api/v1/subscriptions/{uuid}/cancel']['post']['requestBody']
>['content']['application/json'];
export type CancelSubscriptionResponse =
  paths['/api/v1/subscriptions/{uuid}/cancel']['post']['responses'][200]['content']['application/json']['subscription'];

export type RecoverPendingCancelResponse =
  paths['/api/v1/subscriptions/{uuid}/recover_pending_cancel']['post']['responses'][200]['content']['application/json']['subscription'];

export async function createSubscription(
  body: CreateSubscriptionBody
): Promise<CreateSubscriptionResponse> {
  const { data, error } = await client.POST('/api/v1/subscriptions', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating subscription');
  return data.subscription;
}

export async function getMySubscription(): Promise<MySubscriptionResponse> {
  const { data, error } = await client.GET('/api/v1/subscriptions/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting my subscription');
  return data.subscription;
}

export async function changeSubscription(
  body: ChangeSubscriptionBody
): Promise<ChangeSubscriptionResponse> {
  const { data, error } = await client.POST('/api/v1/subscriptions/me/change', {
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when changing subscription');
  return data.subscription;
}

export async function cancelSubscription(
  subscriptionId: string,
  body: CancelSubscriptionBody
): Promise<CancelSubscriptionResponse> {
  const { data, error } = await client.POST('/api/v1/subscriptions/{uuid}/cancel', {
    params: { path: { uuid: subscriptionId } },
    body,
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when canceling subscription');
  return data.subscription;
}

export async function recoverPendingCancel(
  subscriptionId: string
): Promise<RecoverPendingCancelResponse> {
  const { data, error } = await client.POST('/api/v1/subscriptions/{uuid}/recover_pending_cancel', {
    params: { path: { uuid: subscriptionId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when recovering pending cancel');
  return data.subscription;
}